import cx from 'clsx';

import { isActive } from '@/components/BottomNavigation/constants';
import { BottomNavigationItem } from '@/components/BottomNavigation/types';
import LottieAnimation from '@/components/Lottie';

import styles from './BottomNavigationSlot.module.scss';

interface BottomNavigationSlotProps {
  item: BottomNavigationItem;
}

const BottomNavigationSlot = ({
  item: { state, image, title, notification, animation_on_active },
}: BottomNavigationSlotProps) => {
  return (
    <div className={styles.slotContainer} data-testid="bottom-slot-container">
      <div className={styles.iconWrapper}>
        <div
          className={cx([styles.icon, state === 'active' && styles.iconActive])}
          data-testid="icon"
          style={{
            maskImage: `url(${image.source})`,
            WebkitMaskImage: `url(${image.source})`,
          }}
        />
        {state === 'active' && !!animation_on_active && (
          <div className={styles.lottieOverlay}>
            <LottieAnimation
              asset={{
                source: animation_on_active.url,
                alt: 'search_loader_animation',
                subtype: 'json',
              }}
              initialDelay={0}
              loop={false}
            />
          </div>
        )}
      </div>
      <div className={styles.notification}>{notification}</div>
      <p
        className={cx(
          styles.title,
          isActive(state) ? styles.titleActive : styles.titleInactive
        )}
        data-testid="title"
      >
        {title}
      </p>
    </div>
  );
};

export default BottomNavigationSlot;
